import { useEffect } from "react";
import { useDispatch, useSelector } from "../../../../hooks";
import { Loader } from "../../../../components/Loader/Loader";
import { CardWrapper } from "../../../../components/CardWrapper/CardWrapper";
import { ReferalCard } from "../../../../components/ReferalCard/ReferalCard";
import { getReferals } from "../../../../redux/referals/get-referals.handler";

export const ReferalsList = () => {    
    const dispatch = useDispatch();
    const { items, loading } = useSelector(store => store.referals);
    
    useEffect(() => {
        if (items)
            return;

        dispatch(getReferals());
    }, [items, dispatch]);

    return (
        <>
            <CardWrapper>
                {items && items.map((referal, i) => {
                    return (
                        <div key={`referal${i}`}>
                            <ReferalCard {...referal} />
                        </div>
                    );
                })}
            </CardWrapper>
            
            { loading && <Loader /> }
        </>
    );
}